export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.22-1503.34",
  commitId: "f3f50caf1a53646be7788213479534b47bd6f3e1",
  commitTime: "2026-09-22T15:03:34.000Z",
});
